export default __webpack_public_path__ + "static/media/FIN.aeba83d2.svg";